(function () {
    'use strict';

    angular.module("imApp").factory("custactMembersService", ['$ihttp', function ($ihttp) {
        let service = {
            listMembers: function (parms) {
                return $ihttp.post({
                    method: 92,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
